export default [
	{
		path: 'reports/create',
		name: 'create-report-default',
		redirect: route => ({
			name: 'create-report-step1',
			params: {
				companyid: parseInt(route.params.companyid),
				routeReportId:
					route.query.reportid && parseInt(route.query.reportid)
			}
		})
	},
	{
		path: 'reports/create/step/1',
		name: 'create-report-step1',
		meta: {
			pageTitle: 'Create Report',
			desktopOptimized: true
		},
		props: route => ({
			step: 1,
			companyId: parseInt(route.params.companyid),
			routeDataSourceIds: null,
			routeCompanyIds: route.query.companyids || [route.params.companyid],
			routeReportId:
				route.query.reportid && parseInt(route.query.reportid)
		}),
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(
				/* webpackChunkName: "createReport" */ '@/sections/report-generator/create-report/create-report-page.vue'
			)
	},
	{
		path: 'reports/create/step/2',
		name: 'create-report-step2',
		props: route => ({
			step: 2,
			companyId: parseInt(route.params.companyid),
			routeDataSourceIds: route.query.datasourceids || null,
			routeCompanyIds: route.query.companyids || [route.params.companyid],
			routeReportId:
				route.query.reportid && parseInt(route.query.reportid)
		}),
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(
				/* webpackChunkName: "createReport" */ '@/sections/report-generator/create-report/create-report-page.vue'
			)
	},
	{
		path: 'reports/create/step/3',
		name: 'create-report-step3',
		props: route => ({
			step: 3,
			companyId: parseInt(route.params.companyid),
			routeDataSourceIds: route.query.datasourceids || null,
			routeCompanyIds: route.query.companyids || [route.params.companyid],
			routeReportId:
				route.query.reportid && parseInt(route.query.reportid)
		}),
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(
				/* webpackChunkName: "createReport" */ '@/sections/report-generator/create-report/create-report-page.vue'
			)
	},
	{
		path: 'reports/create/step/4',
		name: 'create-report-step4',
		props: route => ({
			step: 4,
			companyId: parseInt(route.params.companyid),
			routeDataSourceIds: route.query.datasourceids || null,
			routeCompanyIds: route.query.companyids || [route.params.companyid],
			routeReportId:
				route.query.reportid && parseInt(route.query.reportid)
		}),
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(
				/* webpackChunkName: "createReport" */ '@/sections/report-generator/create-report/create-report-page.vue'
			)
	}
];
